const leaseIframeContainerId = 'lease-term-iframe-container';
export const openLeaseTerm = (e) => {
  e.preventDefault();
  if (e.target.dataset.iframeUrl) {
    createIframe(e.target.dataset.iframeUrl);
  }
}

const createIframe = (url) => {
  if (url) {
    const leaseIframeContainer = document.createElement('div');
    leaseIframeContainer.setAttribute('id', leaseIframeContainerId);
    const iframe = document.createElement('iframe');
    iframe.src = url;
    const divLoader = document.createElement('div');
    iframe.addEventListener('load', (e) => {
      divLoader.remove();
    });
    divLoader.classList.add('loader');
    divLoader.classList.add('active');
    divLoader.appendChild(document.createElement('span'));
    divLoader.appendChild(document.createElement('span'));
    divLoader.appendChild(document.createElement('span'));
    leaseIframeContainer.appendChild(divLoader);
    leaseIframeContainer.appendChild(iframe);
    leaseIframeContainer.classList.add('show');
    document.body.appendChild(leaseIframeContainer);
    document.body.style.overflow = 'hidden';
    window.addEventListener('message', onCloseLeaseTermsListener);
  }
}

const onCloseLeaseTermsListener = (e) => {
  if (e.data && e.data.includes && e.data.includes('lease-term-modal')) {
    const leaseIframeContainer = document.getElementById(leaseIframeContainerId);
    if (leaseIframeContainer) {
      document.body.style.overflow = 'auto';
      leaseIframeContainer.remove();
      window.removeEventListener('message', onCloseLeaseTermsListener);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/components/lease-term.js